import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import ScrollToTop from 'react-scroll-up'
import Fade from 'react-reveal/Fade'

import hospital from '../assets/images/hospital.svg'
import family from '../assets/images/family.svg'
import arrow from '../assets/images/arrow.svg'

const Bienfaits = (props) => (
  <div>
    <Helmet>
      <html lang="fr" />
      <title>Les bienfaits</title>
      <meta name="description" content="Les bienfaits de la réflexologie" />
    </Helmet>

    <div id="main" className="alt">
      <section id="one">
        <div className="inner">
          <header className="major">
            <h1>Les bienfaits</h1>
          </header>
          <hr></hr>
          <Fade>
            <span className="img main">
              <img src={hospital} alt="icone d'une croix" />
            </span>
            <h2>Les bénéfices</h2>
            <ul>
              <li>Mieux-être physique et psychologique</li>
              <li>Meilleur drainage des toxines</li>
              <li>Soulagement des douleurs</li>
              <li>Meilleure gestion du stress</li>
              <li>Détente et relaxation du corps</li>
              <li>Evacuation des émotions négatives</li>
              <li>Amélioration de la circulation sanguine et lymphatique</li>
              <li>Optimisation du fonctionnement des organes</li>
              <li>Renforcement du système immunitaire</li>
              <li>Diminution des effets secondaires des traitements</li>
              <li>Soulagement des petits maux de la grossesse</li>
            </ul>
            <p>
              Les bienfaits de la Réflexologie sont nombreux, cette liste est
              non exhaustive. La Réflexologie a également, un aspect préventif,
              par la libération des tensions sur le pied, elle permet une
              meilleure capacité d'adaptation au stress.
            </p>
            <hr></hr>
            <span className="img main">
              <img src={family} alt="icone d'une famille" />
            </span>
            <h2>Pour qui ?</h2>
            <p>
              La Réflexologie s'adresse à TOUS, du bébé à la personne âgée.
              J'adapte ma technique et la durée de la séance en fonction de
              chacun. Pour les personnes très fragiles, mon cadre de travail,
              reste le bien-être et la détente.
            </p>
            <p>Il existe quelques contre-indications, comme la présence :</p>
            <ul>
              <li>
                d'inflammation ou d'un traumatisme des pieds (eczéma, mycose
                étendue sur tout le pied).
              </li>
              <li>
                de troubles cardiovasculaires non traités ou non stabilisés.
              </li>
              <li>de phlébite récente ou lymphangite.</li>
              <li>de grossesse à risque.</li>
              <li>es 3 premiers mois de la grossesse.</li>
            </ul>
            <p>
              La Réflexologie est une pratique qui se place en complémentarité
              de la médecine conventionnelle.
            </p>
            <p>
              Elle ne permet en aucun cas de modifier les prescriptions
              médicales, ni de poser un diagnostic. La Réflexologie ne se
              substitue à aucun traitement médical.
            </p>
          </Fade>
          <ScrollToTop showUnder={160}>
            <span className="img main">
              <img src={arrow} alt="icone fleche" />
            </span>
          </ScrollToTop>
        </div>
      </section>
    </div>
  </div>
)

export default Bienfaits



// WEBPACK FOOTER //
// ./src/pages/bienfaits.js